import { Checkbox, InputWrapper, Stack } from '@mantine/core';
import { useController } from 'react-hook-form';
import type { FieldValues, UseControllerProps } from 'react-hook-form';

import { toStringArray } from '../../lib/toStringArray.ts';

type CheckboxSelectProps<T extends FieldValues> = UseControllerProps<T> & {
  data: { label: string; value: string }[];
  label: string;
};

export function CheckboxSelect<T extends FieldValues>({
  name,
  control,
  defaultValue,
  rules,
  shouldUnregister,
  data,
  ...props
}: CheckboxSelectProps<T>) {
  const {
    field: { value: fieldValue, onChange },
    fieldState,
  } = useController<T>({
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
  });
  const value = toStringArray(fieldValue);

  return (
    <InputWrapper {...props} error={fieldState.error?.message}>
      <Stack component="ul" gap="sm" m={0} mt="xs" p={0} style={{ listStyle: 'none' }}>
        {data.map((item) => {
          const active = value.includes(item.value);

          return (
            <li key={item.value}>
              <Checkbox
                checked={active}
                color="grape.6"
                label={item.label}
                name={item.label}
                radius="xs"
                styles={{
                  input: { cursor: 'pointer' },
                  label: {
                    cursor: 'pointer',
                    fontSize: '18px',
                    fontWeight: '300',
                  },
                }}
                onChange={() =>
                  onChange(active ? value.filter((valueItem) => valueItem !== item.value) : [...value, item.value])
                }
              />
            </li>
          );
        })}
      </Stack>
    </InputWrapper>
  );
}
